import { render, staticRenderFns } from "./modularTabbar.vue?vue&type=template&id=03ff30a0&scoped=true"
import script from "./modularTabbar.vue?vue&type=script&lang=js"
export * from "./modularTabbar.vue?vue&type=script&lang=js"
import style0 from "./modularTabbar.vue?vue&type=style&index=0&id=03ff30a0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff30a0",
  null
  
)

export default component.exports